function setSampleFilters (sampleId, filters) {
  if (!this.dbClient) return
  return this.dbClient.samples.update(sampleId, { filters })
}

export default setSampleFilters